import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import ProductBiddingListItem from '../../components/bids/ProductBiddingListItem'
import Pagination from '../../components/common/Pagination'
import productRequestTypes from '../../constants/productRequestTypes'
import PageTitle from '../../components/common/PageTitle'
import SeoHelmet from '../../components/common/SeoHelmet'

const ProductBiddingListPage = () => {
  const [currentPage, setCurrentPage] = useState(1)

  const queryParams = {
    page: currentPage,
    bidRequestType: productRequestTypes.bidding.key,
  }
  const { data: bidListData } = useQuery({
    queryKey: QueryKeys.bidsList(queryParams),
    queryFn: () => handleGetRequest(`/customer/bids/requests`, queryParams),
  })
  const bids = bidListData?.data || []

  const renderBids = () => {
    if (!bids?.length) {
      return <p className="text-center text-gray-500 mt-8">No active product bids found.</p>
    }
    return bids.map((bid) => <ProductBiddingListItem key={bid.id} bid={bid} />)
  }

  return (
    <div className="main-container">
      <SeoHelmet
        title="My Product Bids"
        description="Track your product bid requests and view responses from retailers and wholesalers on Sokooni marketplace. Manage your active bids and negotiations."
        keywords="product bids, bid requests, supplier bids, price quotes, bid management, Sokooni bids"
        url="/bids"
      />
      <PageTitle>Product Bidding</PageTitle>
      <div className="space-y-4">{renderBids()}</div>
      <Pagination paginationMeta={bidListData?.meta} onPageChange={setCurrentPage} />
    </div>
  )
}

export default ProductBiddingListPage
